import React, { useState, useCallback, useEffect, Fragment } from 'react'
import ListIcon from 'custom/assets/common-icons/List.svg'
import '../../styles/SelectedAccountSection.css'
import moment from 'moment'
import NumberFormat from 'react-number-format'
import i18n from '../../i18n'
import { ACCOUNT_CARD_KEYS } from '../../utils/translation-constants'
import config from 'custom/config/environment'

const accountTypes = {
  U: ACCOUNT_CARD_KEYS.CURRENT_ACC,
  S: ACCOUNT_CARD_KEYS.SAVING_ACC,
  C: ACCOUNT_CARD_KEYS.CURRENT_ACC,
  WA: ACCOUNT_CARD_KEYS.WALLET_ACC,
  SA: ACCOUNT_CARD_KEYS.SAVING_ACC,
  W: ACCOUNT_CARD_KEYS.WALLET_ACC,
}

export default class SelectedAccountSection extends React.Component {
  constructor(props) {
    super(props)
    this.close = this.closesection.bind(this)
  }
  closesection() {
    this.props.close(this)
  }
  render() {
    const selectedAccount = this.props.selectedAccount
    return (
      <div className='selected-account position-absolute my-3'>
        <div className='row mb-3'>
          <div className='d-flex mt-2 col-sm-10'>
            <div className=''>
              <img src={ListIcon} alt='' />
            </div>
            <div className='pl-4'>
              <div className='font-weight-500' style={{ fontSize: 10 }}>
                {i18n.t(ACCOUNT_CARD_KEYS.VIEW_ACC_DETAILS)}
              </div>
              <div style={{ fontSize: 16, fontWeight: 800 }}>{selectedAccount.accountNo}</div>
            </div>
          </div>
          <div className='col-sm-2'>
            <i
              className='material-icons'
              style={{ marginTop: 10, cursor: 'pointer' }}
              onClick={() => this.close()}>
              close
            </i>
          </div>
        </div>
        <div className='row my-3'>
          <div className='col-6 font-weight-500'> {i18n.t(ACCOUNT_CARD_KEYS.ACCOUNT_TYPE)}</div>
          <div className='col-6 font-weight-bold'>
            {i18n.t(accountTypes[selectedAccount.accountType])}
            {/* {selectedAccount.accountType === 'S' &&  i18n.t(ACCOUNT_CARD_KEYS.SAVING_ACC)}
            {(selectedAccount.accountType === 'C' || selectedAccount.accountType === 'U') &&
            i18n.t(ACCOUNT_CARD_KEYS.CURRENT_ACC)}
            {selectedAccount.accountType === 'WA' && i18n.t(ACCOUNT_CARD_KEYS.WALLET_ACC)} */}
          </div>
        </div>

        <div className='row my-3'>
          <div className='col-6 font-weight-500'>{i18n.t(ACCOUNT_CARD_KEYS.ACC_NICK_NAME)}</div>
          <div className='col-6 font-weight-bold' style={{ wordBreak: 'break-all' }}>
            {selectedAccount.accountNickName || '-'}
          </div>
        </div>
        <div className='row my-3'>
          <div className='col-6 font-weight-500'>{i18n.t(ACCOUNT_CARD_KEYS.ACC_HOLDER_NAME)}</div>
          <div className='col-6 font-weight-bold'>{selectedAccount.customerName || '-'}</div>
        </div>
        <div className='row my-3'>
          <div className='col-6 font-weight-500'>{i18n.t(ACCOUNT_CARD_KEYS.CUST_ID)}</div>
          <div className='col-6 font-weight-bold'>{selectedAccount.custNo || '-'}</div>
        </div>
        <div className='row my-3'>
          <div className='col-6 font-weight-500'>{i18n.t(ACCOUNT_CARD_KEYS.BRANCH)}</div>
          <div className='col-6 font-weight-bold'>
            {selectedAccount.brnName === '' || null
              ? selectedAccount.brnCode
              : selectedAccount.brnCode + ' - ' + selectedAccount.brnName}
          </div>
        </div>
        {config.CLIENT_NAME !== 'NBS' &&
          config.CLIENT_NAME !== 'NFC' &&
          selectedAccount.accountType !== 'W' && (
            <div className='row my-3'>
              <div className='col-6 font-weight-500'>{i18n.t(ACCOUNT_CARD_KEYS.SORT_CODE)}</div>
              <div className='col-6 font-weight-bold'>{selectedAccount?.sortCode || '-'}</div>
            </div>
          )}
        {config.CLIENT_NAME !== 'NBS' && (
          <div className='row my-3'>
            <div className='col-6 font-weight-500'>{i18n.t(ACCOUNT_CARD_KEYS.SWIFT_CODE)}</div>
            <div className='col-6 font-weight-bold'>{selectedAccount?.swiftCode || '-'}</div>
          </div>
        )}
        <div className='row my-3'>
          <div className='col-6 font-weight-500'>{i18n.t(ACCOUNT_CARD_KEYS.CURRENCY)}</div>
          <div className='col-6 font-weight-bold'>{selectedAccount.currency || '-'}</div>
        </div>

        <div className='row my-3'>
          <div className='col-6 font-weight-500'>{i18n.t(ACCOUNT_CARD_KEYS.AVA_BALANCE)}</div>
          <div className='col-6 font-weight-bold'>
            <NumberFormat
              value={selectedAccount?.avlBal}
              thousandSeparator={true}
              displayType={'text'}
              fixedDecimalScale={true}
              decimalScale={2}
              allowEmptyFormatting
            />
          </div>
        </div>
        <div className='row my-3'>
          <div className='col-6 font-weight-500'>{i18n.t('Current Balance')}</div>
          <div className='col-6 font-weight-bold'>
            <NumberFormat
              value={selectedAccount?.currBal}
              thousandSeparator={true}
              displayType={'text'}
              fixedDecimalScale={true}
              decimalScale={2}
              allowEmptyFormatting
            />
          </div>
        </div>
        <div className='row my-3'>
          <div className='col-6 font-weight-500'>{i18n.t(ACCOUNT_CARD_KEYS.ACC_OPEN_DATE)}</div>
          <div className='col-6 font-weight-bold'>
            {moment(selectedAccount.accountOpeningDate || '-').format('DD-MM-YYYY')}
          </div>
        </div>

        <div className='row my-3'>
          <div className='col-6 font-weight-500'>{i18n.t(ACCOUNT_CARD_KEYS.ACC_DESC)}</div>
          <div className='col-6 font-weight-bold'>{selectedAccount?.accDesc || '-'}</div>
        </div>
      </div>
    )
  }
}
